module.exports = __webpack_public_path__ + "media/form_icons/social_name-55aae2ba.png";